module.exports = __webpack_public_path__ + "static/media/gooseLogo.1454b634.png";